import { TagBootloaderState } from '../types'
import TagBootloader from '../../models/tagBootloader'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'

//Get an Bootloader from a Vue component by calling this.$store.state.bootloader.list;

const state: TagBootloaderState = {
    list: [],
}

const getters: GetterTree<TagBootloaderState, any> = {
    getTagBootloaderList: state => () => {
        return state.list;
    },
    getTagBootloader: state => (Id: number) => {
        return state.list.find(f => f.tag_bootloader_id == Id);
    }
}

const mutations: MutationTree<TagBootloaderState> = {
    setTagBootloaderList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((tagBootloader: TagBootloader, index) => {
            Vue.set(state.list, index, tagBootloader);
        });
    }
}

const actions: ActionTree<TagBootloaderState, any> = {
    async fetchTagBootloader({ commit, state, dispatch }, id) {
        if (id && !state.list.find(f => f.tag_bootloader_id == id)) {
            await dispatch('fetchTagBootloaders');
        }
    },
    async fetchTagBootloaders({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/remote/tagbootloader";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<TagBootloader[]>>)
            .then(data => {
                if (data.result && data.result.length > 0) {
                    const bootloaders = [];
                    data.result.forEach(f => {
                        bootloaders.push(new TagBootloader(f));
                    })
                    commit('setTagBootloaderList', bootloaders);
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}